export { default } from './DetailedCarInfoMessage';
